import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const GET_PAYER_PROCEDURE_CODE_LIST = "GET_PAYER_PROCEDURE_CODE_LIST";

export const service = async (data) => { 
  data.limit="5";
  const options: object = {
    url: "/api/DenialsPredictor/GetPayerAndProcedureCodeList",
    method: "POST",
    headers: {
      "Content-Type": "application/json",},
    body: JSON.stringify(data),
  };
  const response = callMvcApi(options);
  return response;
};
const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};


register(GET_PAYER_PROCEDURE_CODE_LIST, service, mock);
